import { FaFacebookF, FaInstagram } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { siteMetadata } from '../config/siteMetadata';

const socialLinkClass =
  'inline-flex h-9 w-9 items-center justify-center border border-[#cfc7b6] text-[#43513f] transition-colors hover:border-[#8e3a2b] hover:bg-[#f4efe3] hover:text-[#8e3a2b] focus:outline-none focus:ring-2 focus:ring-[#8e3a2b] focus:ring-offset-2 focus:ring-offset-[#fbf8ef]';

const siteMapLinks = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/events', label: 'Events' },
  { to: '/contact', label: 'Contact' },
  { to: '/apply', label: 'Join' },
];

const mapUrl = `https://www.google.com/maps?q=${siteMetadata.geo.latitude},${siteMetadata.geo.longitude}`;
const addressLine = `${siteMetadata.address.streetAddress}, ${siteMetadata.address.addressLocality}, ${siteMetadata.address.addressRegion} ${siteMetadata.address.postalCode}`;

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-[#d8d0be] bg-[#fbf8ef] text-[#43513f]">
      <div className="mx-auto max-w-[92rem] px-6 py-8 sm:px-10 md:py-10 lg:px-16">
        <div className="grid gap-6 border-b border-[#d8d0be] pb-7 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-end">
          <div className="max-w-2xl">
            <div className="text-[#10351f]">
              <span className="block font-serif text-2xl leading-none sm:text-3xl">
                Pleasant Playground
              </span>
              <span className="mt-2 block text-[0.6rem] font-semibold uppercase tracking-[0.42em] text-[#253f2d] sm:text-xs">
                Community Garden
              </span>
            </div>
            <p className="mt-4 text-sm leading-6 text-[#445044]">
              A neighborhood garden where neighbors grow fresh food, learn organic gardening, and build community.
            </p>
          </div>

          <div className="flex flex-col gap-3 sm:flex-row lg:justify-end">
            <Link
              to="/apply"
              className="inline-flex items-center justify-between gap-5 border border-[#43513f] bg-[#10351f] px-4 py-3 text-sm font-medium text-[#fbf8ef] transition-colors hover:bg-[#0a2416] focus:outline-none focus:ring-2 focus:ring-[#8e3a2b] focus:ring-offset-2 focus:ring-offset-[#fbf8ef]"
            >
              <span>Join</span>
              <span aria-hidden="true">&rarr;</span>
            </Link>
            <a
              href="https://www.gofundme.com/f/feed-families-fund-summer-jobs-for-teens"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-between gap-5 border border-[#cfc7b6] px-4 py-3 text-sm font-medium text-[#10351f] transition-colors hover:border-[#8e3a2b] hover:bg-[#f4efe3] focus:outline-none focus:ring-2 focus:ring-[#8e3a2b] focus:ring-offset-2 focus:ring-offset-[#fbf8ef]"
            >
              <span>Support</span>
              <span aria-hidden="true">&rarr;</span>
            </a>
          </div>
        </div>

        <div className="grid gap-7 py-7 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-start">
          <nav aria-label="Footer site map">
            <h2 className="sr-only">Footer site map</h2>
            <div className="flex flex-wrap gap-x-5 gap-y-3">
              {siteMapLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-sm font-medium text-[#243c2c] hover:text-[#8e3a2b]"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </nav>

          <div className="grid gap-3 text-sm lg:justify-items-end lg:text-right">
            <a
              href={mapUrl}
              target="_blank"
              rel="noreferrer"
              className="text-[#243c2c] underline decoration-[#cfc7b6] underline-offset-4 hover:text-[#8e3a2b]"
            >
              {addressLine}
            </a>
            <a
              href={`mailto:${siteMetadata.email}`}
              className="font-medium text-[#243c2c] hover:text-[#8e3a2b]"
            >
              {siteMetadata.email}
            </a>
            <div className="flex items-center gap-3 lg:justify-end">
              <a
                href="https://www.instagram.com/pleasantgarden/"
                target="_blank"
                rel="noreferrer"
                className={socialLinkClass}
                aria-label="Instagram"
                title="Instagram"
              >
                <FaInstagram className="h-5 w-5" aria-hidden="true" />
              </a>
              <a
                href="https://www.facebook.com/pleasantgarden215/"
                target="_blank"
                rel="noreferrer"
                className={socialLinkClass}
                aria-label="Facebook"
                title="Facebook"
              >
                <FaFacebookF className="h-5 w-5" aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[#d8d0be] pt-5 text-xs text-[#5b695c]">
          <p>{siteMetadata.name} &copy; {year}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
